import { MouseEvent } from 'react';
import { Button } from 'components/core/button';
import { H3, Text } from 'components/core/text/Text';
import { Modal, ModalBody } from 'components/modal/Modal';
import { useConsult } from 'contexts/ConsultContext';
import SuccessFloss from 'public/assets/img/buddies/success-floss-circle.gif';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

interface EligibilitySuccessModalProps {
  isNpReferralOnly?: boolean;
  selfNpReferFlow?: boolean;
  to?: string;
}
export const EligibilitySuccessModal = ({
  isNpReferralOnly,
  selfNpReferFlow,
  to,
}: EligibilitySuccessModalProps) => {
  const { consult } = useConsult();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const goNext = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (to) {
      return navigate(to);
    }
    if (selfNpReferFlow) {
      navigate(`/np/members/${consult?.patientId}/agreements`);
      return;
    }
    if (isNpReferralOnly) {
      navigate(
        `/member/${consult?.patientId}/agreements/${params['consultId']}`,
      );
      return;
    }
    if (location?.state?.to) {
      return navigate(location.state.to);
    }

    window.location.replace(e.currentTarget.href);
  };

  return (
    <Modal noSneezeColor onClose={() => {}}>
      <ModalBody className="max-w-[458px]">
        <img src={SuccessFloss} className="pb-6 h-[200px] sm:h-full" />

        <H3>Good news!</H3>
        <Text className="pb-8 text-center" block variant="text2">
          Bend Health accepts your insurance!
        </Text>
        <Link
          to={`/consult/${params['consultId']}/start`}
          className="w-full flex justify-center"
          data-testid="linkButton"
          onClick={goNext}
        >
          <Button>Continue</Button>
        </Link>
      </ModalBody>
    </Modal>
  );
};
